<template>
    <div>
      <el-dialog
        :title="title"
        :visible="isShowGoogleAuthDialog"
        width="30%"
        @close="handleDialog"
        @open="init"
        :close-on-click-modal="false"
      >

      <div v-show="showBind">



        <br>
        <br>
        <br>
        <h4>请输入google验证码</h4>

        <br>
        <br>

        <el-input
          v-model="form.tmpCode"
          placeholder="请输gogole验证码"
          style="width: 350px"
        ></el-input>
        
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>

        <el-button type="success" @click="bindAuthConfirm">登录</el-button>
      </div>

      <!-- <a id="login_tg_url" target="view_window" :href="url">{{msg}}</a> -->

    </el-dialog>
    </div>
  </template>
  <script>

  export default {
    props: {
      isShowGoogleAuthDialog: {
        type: Boolean,
        default: false,
      },
      url: {
        type: String,
        default: '',
      },
      msg: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        title:'登录验证',
        showBind: true,
        rules: {},
        form:{
          tmpCode: "",
        }
      }
    },
    methods: {
      init(){
      },
      handleDialog() {
        this.$emit('update:isShowLoginDialog', false)
      },
      submit() {
      },

      bindAuthConfirm() {
        console.log(this.form.tmpCode)
        this.axios.post("/auth/googleAuthLogin", {
            code: this.form.tmpCode,
            authCode: this.url,
        }).then(res => {
            if (res.code === 200) {

              console.log("googleAuthLogin_result:" + res.data.token);

              this.loginSuccess(res)

            } else {
                // this.$notify.error({
                //     title: '验证错误',
                //     message: res.msg,
                // });
            }
        })
      },
      
      loginSuccess(res) {
        this.$store.commit('setIsLogin', true)
        this.$store.commit('setUserId', res.data.userId)
        this.$store.commit('setUserName', res.data.userName)
        this.$store.commit('setRoutes', res.data.routes)
        this.$store.commit('setToken', res.data.token)
        this.$store.commit('setProdStatus', res.data.prodStatus)
        this.$store.commit('setRoleId', res.data.roleId)
        sessionStorage.setItem('store', JSON.stringify(this.$store.state))
        this.loadingLogin = false
        this.isShowLoginDialog = false
        this.$router.push('/')
        // console.log("bbbbbbbbbbbbbbbbbb")
      },


    },
  }
  </script>